import { Route, Routes } from 'react-router'

import { NotFound } from 'js/core/NotFound'
import RequireAuth from 'js/router/RequireAuth'

import List from './List'

const Component = () => (
    <Routes>
        <Route
            index
            element={
                <RequireAuth viewer="loggedIn">
                    <List />
                </RequireAuth>
            }
        />
        <Route path="*" element={<NotFound />} />
    </Routes>
)

export default Component
